import { render, staticRenderFns } from "./advertSwiper.vue?vue&type=template&id=75b13ea6&scoped=true&"
import script from "./advertSwiper.vue?vue&type=script&lang=js&"
export * from "./advertSwiper.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./advertSwiper.vue?vue&type=style&index=0&id=75b13ea6&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "75b13ea6",
  "78a8bce1"
  
)

export default component.exports